import { ConnectorFilter } from "@mirage/shared/search/search-filters";

export const chatConnectors: Record<string, boolean> = {
  "custom.teams": true,
  slack: true,
};

export function removeOppositeConnectorTypes(
  filters: ConnectorFilter[],
  connectorId: string,
): ConnectorFilter[] {
  const incomingIsChatConnector = chatConnectors[connectorId] ?? false;
  return filters.filter((filter) => {
    const isChatConnector = chatConnectors[filter.id] ?? false;
    if (incomingIsChatConnector) {
      return isChatConnector;
    } else {
      return !isChatConnector;
    }
  });
}
